// src/index.tsx
import dynamic from "next/dynamic";
import React, { useEffect, useRef, useState } from "react";
var hydrateClientSide = (Component, options) => {
  const { rootMargin } = options;
  const Hydration = ({ ...props }) => {
    const rootRef = useRef(null);
    const [isHydrated, setIsHydrated] = useState(false);
    const initIntersectionObserver = (rootMargin2) => {
      const observerOptions = {
        rootMargin: rootMargin2
      };
      const shouldHydrate = !("IntersectionObserver" in window) || !rootRef.current;
      if (shouldHydrate) {
        setIsHydrated(true);
        return;
      }
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          setIsHydrated(true);
        }
      }, observerOptions);
      observer.observe(rootRef.current);
      return () => observer.disconnect();
    };
    useEffect(() => {
      if (!isHydrated) {
        return initIntersectionObserver(rootMargin);
      }
      return;
    }, [isHydrated]);
    if (isHydrated) {
      return /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement(Component, { ...props }));
    }
    return /* @__PURE__ */ React.createElement("section", { ref: rootRef, dangerouslySetInnerHTML: { __html: "" }, suppressHydrationWarning: true });
  };
  return Hydration;
};
var lazyHydrate = (component, options) => {
  const LoadingComponent = options?.LoadingComponent ?? void 0;
  const Component = dynamic(component, {
    ssr: true,
    ...!!LoadingComponent && {
      loading: () => /* @__PURE__ */ React.createElement(LoadingComponent, null)
    }
  });
  const isServer = typeof window === "undefined";
  return isServer ? ({ ...props }) => /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement(Component, { ...props })) : hydrateClientSide(Component, { rootMargin: options?.rootMargin || "0px 250px" });
};
export {
  lazyHydrate
};
